import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { ConfirmDialog, Dialog } from "@bookips/sds";
import { useDialogStore } from "src/store/useDialogStore";
const DialogProvider = ()=>{
    const { dialogs , close  } = useDialogStore();
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: Object.values(dialogs).map((dialog)=>{
            const { id  } = dialog;
            if (dialog.type === "confirm") {
                const { onCancel , onConfirm , onOpenChange , open , ...restConfirm } = dialog.props;
                return /*#__PURE__*/ _jsx(ConfirmDialog, {
                    onCancel: ()=>{
                        onCancel === null || onCancel === void 0 ? void 0 : onCancel();
                        close(id);
                    },
                    onConfirm: ()=>{
                        onConfirm === null || onConfirm === void 0 ? void 0 : onConfirm();
                        close(id);
                    },
                    open: open || false,
                    onOpenChange: ()=>{
                        return onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange();
                    },
                    ...restConfirm
                }, id);
            }
            const { onOpenChange , open , ...rest } = dialog.props;
            return /*#__PURE__*/ _jsx(Dialog, {
                open: open || false,
                onOpenChange: ()=>{
                    return onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange();
                },
                ...rest
            }, id);
        })
    });
};
export default DialogProvider;
